import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/Login',
    component: resolve => require(['@/page/Login.vue'], resolve),
  }, {
    path: '/',
    component: resolve => require(['@/page/index.vue'], resolve),
    redirect: '/banner_mag',
    children: [{
        path: '/case_mag',
        component: resolve => require(['@/page/case_mag.vue'], resolve),
      }, {
        path: '/add_case',
        component: resolve => require(['@/page/add_case.vue'], resolve),
      }, {
        path: '/classify_mag',
        component: resolve => require(['@/page/classify_mag.vue'], resolve),
      }, {
        path: '/add_classify',
        component: resolve => require(['@/page/add_classify.vue'], resolve),
      }, {
        path: '/banner_mag',
        component: resolve => require(['@/page/banner_mag.vue'], resolve),
      }, {
        path: '/add_banner',
        component: resolve => require(['@/page/add_banner.vue'], resolve),
      }, {
        path: '/ecology',
        component: resolve => require(['@/page/ecology.vue'], resolve),
      }, {
        path: '/add_ecology',
        component: resolve => require(['@/page/add_ecology.vue'], resolve),
      }, {
        path: '/ecology_clas',
        component: resolve => require(['@/page/ecology_clas.vue'], resolve),
      }, {
        path: '/add_ecology_clas',
        component: resolve => require(['@/page/add_ecology_clas.vue'], resolve),
      }, {
        path: '/add_partner',
        component: resolve => require(['@/page/add_partner.vue'], resolve),
      }, {
        path: '/partner',
        component: resolve => require(['@/page/partner.vue'], resolve),
      }, {
        path: '/industry_msg',
        component: resolve => require(['@/page/industry_msg.vue'], resolve),
      }, {
        path: '/add_industry',
        component: resolve => require(['@/page/add_industry.vue'], resolve),
      }, {
        path: '/about_us',
        component: resolve => require(['@/page/about_us.vue'], resolve),
      }, {
        path: '/contact',
        component: resolve => require(['@/page/contact.vue'], resolve),
      },
      {
        path: '/friendship',
        component: resolve => require(['@/page/friendship.vue'], resolve),
      }, {
        path: '/add_friendship',
        component: resolve => require(['@/page/add_friendship.vue'], resolve),
      },
      {
        path: '/add_shop',
        component: resolve => require(['@/page/add_shop.vue'], resolve),
      }, {
        path: '/shop_mag',
        component: resolve => require(['@/page/shop_mag.vue'], resolve),
      },

    ]
  }],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js